import { AuthPage } from "./view/components/AuthPage";

function App() {
  return <AuthPage />;
}

export default App;
